<template>
  <div>
    <v-app style="background-color:black">
      <v-main style="height:100vh;">
        <Particles1 />
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="7">
            <v-row align="center" justify="center" style="height:100vh;">
              <v-img
                height="14%"
                class="floating"
                src="https://firebasestorage.googleapis.com/v0/b/faststartup.appspot.com/o/titlu%20(1).png?alt=media&token=6ad12ca4-9af1-4fed-833e-d2c1453f94a2"
              ></v-img>
            </v-row>
          </v-col>
          <v-fab-transition>
            <v-btn
              v-scroll="onScroll"
              v-show="fab"
              bottom
              fab
              color="white"
              large
              fixed
              @click="$vuetify.goTo('#getstarted')"
            >
              <v-icon color="black" large>mdi-arrow-down</v-icon>
            </v-btn>
          </v-fab-transition>
          <!-- <v-btn
            class="mb-2"
            bottom
            right
            absolute
            outlined
            color="white"
            @click="offerpage()"
          >
            <v-card-text style="color:white;" class="pa-0"
              >get started</v-card-text
            >
          </v-btn> -->
        </v-row>
      </v-main>
      <v-divider style="background-color:white;"></v-divider>
      <v-main style="height:100vh;">
        <v-card color="black">
          <v-row style="height:100%;" no-gutters>
            <v-col cols="12">
              <v-row
                align="end"
                justify="center"
                style="height:10vh;"
                no-gutters
              >
                <v-col>
                  <p style="color:white;" class="text-center titlu pt-2">
                    A little introduction
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-row
              align="center"
              justify="center"
              style="height:90vh;"
              no-gutters
            >
              <v-col cols="10" xs="11" sm="10" md="10" lg="10" xl="10">
                <p
                  style="color:white;line-height:200%;"
                  class="text-center text"
                >
                  FastStartUp is an enthusiastic young company that aims to help
                  develop our society, make life easier and save time. Our
                  company aims to facilitate several vital processes from
                  starting a company, growing a company and developing a
                  company. We present services to promote your company,
                  integration in the online environment, vital for a company
                  nowadays, ensuring the safety and efficiency of your team.
                  Take a look at the services we provide!
                </p>
              </v-col>
            </v-row>
          </v-row>
        </v-card>
      </v-main>
      <v-divider style="background-color:white;"></v-divider>
      <v-main id="getstarted" style="height:100vh;">
        <Particles2 />
        <v-row align="center" justify="center" style="height:100%;" no-gutters>
          <v-btn
            large
            tile
            outlined
            depressed
            color="white"
            @click="offerpage()"
          >
            <v-card-text style="color:white;" class="pa-0"
              >get started</v-card-text
            >
          </v-btn>
        </v-row>
      </v-main>
    </v-app>
  </div>
</template>
<script>
export default {
  name: "StartPage",
  components: {
    Particles1: () => import("./Particles1"),
    Particles2: () => import("./Particles2"),
  },
  data() {
    return {
      fab: true,
    };
  },
  methods: {
    offerpage() {
      this.$router.push("/offers");
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top <= 15;
    },
  },
};
</script>
<style scoped>
.floating {
  animation-name: floating;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
@keyframes floating {
  from {
    transform: translate(0, 0px);
  }
  65% {
    transform: translate(0, 15px);
  }
  to {
    transform: translate(0, -0px);
  }
}
@media screen and (min-width: 1904px) {
  p.titlu {
    font-size: 65px;
  }
  p.text {
    font-size: 45px;
  }
}
@media screen and (max-width: 1904px) {
  p.titlu {
    font-size: 53px;
  }
  p.text {
    font-size: 38px;
  }
}
@media screen and (max-width: 1264px) {
  p.titlu {
    font-size: 43px;
  }
  p.text {
    font-size: 28px;
  }
}
@media screen and (max-width: 960px) {
  p.titlu {
    font-size: 30px;
  }
  p.text {
    font-size: 20px;
  }
}
@media screen and (max-width: 600px) {
  p.titlu {
    font-size: 25px;
  }
  p.text {
    font-size: 16px;
  }
}
@media screen and (max-width: 500px) {
  p.titlu {
    font-size: 24px;
  }
  p.text {
    font-size: 16px;
  }
}
@media screen and (max-width: 300px) {
  p.titlu {
    font-size: 15px;
  }
  p.text {
    font-size: 7px;
  }
}
</style>
